module.exports = __webpack_public_path__ + "static/media/eccommerce.86c96c0b.webp";